import type { SessionRecordingDecision } from '@unify/fhir-model/resources/consent';

export type SessionRecordingSwitchAction = 'none' | 'revoke' | 'open-opt-in';

export type SessionRecordingSwitchUiState = {
  checked: boolean;
  /** True when Pending (no Consent yet / draft-only). */
  pending: boolean;
  disabled: boolean;
  /** Action when the user flips the switch to `nextChecked`. */
  actionForToggle: (nextChecked: boolean) => SessionRecordingSwitchAction;
};

/**
 * Maps resolver decision → Settings Security switch behavior (plan matrix).
 */
export function getSessionRecordingSwitchUiState(
  decision: SessionRecordingDecision,
  opts?: { loading?: boolean; saving?: boolean },
): SessionRecordingSwitchUiState {
  const pending = decision === 'none' || decision === 'pending';
  const checked = decision === 'permitted';
  const busy = Boolean(opts?.loading || opts?.saving);
  return {
    checked,
    pending,
    disabled: busy || pending,
    actionForToggle: (nextChecked: boolean) => {
      if (pending || busy) return 'none';
      if (decision === 'permitted' && !nextChecked) return 'revoke';
      if ((decision === 'denied' || decision === 'revoked') && nextChecked) return 'open-opt-in';
      return 'none';
    },
  };
}
